import {
  Component,
  OnInit
} from '@angular/core';
import { Router } from '@angular/router';

interface PromotionTagItem {
  id: number;
  name: string;
}


@Component({
  selector: 'app-promotional-tag',
  standalone: false,
  templateUrl: './promotional-tag.html',
  styleUrl: './promotional-tag.scss',
})
export class PromotionalTag  implements OnInit {
   pageTitle =
    'Special Promotion Tag List';

  pageSubtitle =
    'View, manage, and organize special course promotion tags in one place.';

  searchTerm = '';

  page = 1;
  pageSize = 10;

  promotionTags: PromotionTagItem[] = [
    {
      id: 1,
      name: 'Trending',
    },
    {
      id: 2,
      name: 'Discount',
    },
  ];

  filteredPromotionTags:
    PromotionTagItem[] = [];

  constructor(
    private readonly router: Router
  ) {}

  ngOnInit(): void {
    this.applyFilters();
  }

  get paginatedPromotionTags():
    PromotionTagItem[] {
    const startIndex =
      (this.page - 1) * this.pageSize;

    const endIndex =
      startIndex + this.pageSize;

    return this.filteredPromotionTags.slice(
      startIndex,
      endIndex
    );
  }

  get startItem(): number {
    if (
      this.filteredPromotionTags.length === 0
    ) {
      return 0;
    }

    return (
      (this.page - 1) * this.pageSize + 1
    );
  }

  get endItem(): number {
    return Math.min(
      this.page * this.pageSize,
      this.filteredPromotionTags.length
    );
  }

  getSerialNumber(index: number): number {
    return (
      (this.page - 1) *
        this.pageSize +
      index +
      1
    );
  }

  onSearchChange(): void {
    this.page = 1;
    this.applyFilters();
  }

  onPageSizeChange(event: Event): void {
    const selectElement =
      event.target as HTMLSelectElement;

    this.pageSize = Number(
      selectElement.value
    );

    this.page = 1;
  }

  applyFilters(): void {
    const normalizedSearch =
      this.searchTerm
        .trim()
        .toLowerCase();

    this.filteredPromotionTags =
      this.promotionTags.filter(
        (promotionTag) =>
          promotionTag.name
            .toLowerCase()
            .includes(normalizedSearch)
      );

    const lastAvailablePage = Math.max(
      1,
      Math.ceil(
        this.filteredPromotionTags.length /
          this.pageSize
      )
    );

    if (this.page > lastAvailablePage) {
      this.page = lastAvailablePage;
    }
  }

  clearFilters(): void {
    this.searchTerm = '';
    this.page = 1;

    this.applyFilters();
  }

  addPromotionTag(): void {debugger;
    this.router.navigate([
      '/admin/course-reference/add-promotional-tag'
    ]);
  }

  // manageCourses(
  //   promotionTag: PromotionTagItem
  // ): void {debugger;
  //   this.router.navigate([
  //     '/admin/course-reference/courses-in-promotion',
  //     promotionTag.id
  //   ]);
    
  // }

  editPromotionTag(
    promotionTag: PromotionTagItem
  ): void {
    this.router.navigate([
      '/admin/course-reference/promotional-tag/edit',
      promotionTag.id
    ]);
  }

  deletePromotionTag(
    promotionTag: PromotionTagItem
  ): void {
    console.log(
      'Delete promotion tag:',
      promotionTag
    );
  }

  trackByPromotionTagId(
    _index: number,
    promotionTag: PromotionTagItem
  ): number {
    return promotionTag.id;
  }
}
